import dynamic from "next/dynamic";

const UserComment        = dynamic ( () => import ( "_components/features/chat/userComment" ) );
const RenderPollComments = dynamic ( () => import ( "./renderPollComments" ) );
const RenderChatTip      = dynamic ( () => import ( "./renderChatTip" ) );

const component = props => {
	const {
		comment,
		emotesList,
		isStreamer,
		handleDropDownPopup,
		isPopUpOpen,
		userProfile,
		selectedComment,
		streamerName,
		handleChatTips,
		userId,
		isFollowingUser,
		isModerator,
		togglePolls,
		handleModal,
		userPopover
	} = props;

	let profileHref;
	let isOwnProfile = false;

	if ( comment?.sportsFan ) {
		profileHref = `/profile/${ comment?.sportsFan.id }`;

		if ( userProfile && comment?.sportsFan.id === userProfile.id ) {
			isOwnProfile = true;
		}
	}

	if ( comment?.type === "USER_COMMENT" ) {
		return (
			<UserComment
				comment             = { comment }
				emotesList          = { emotesList }
				handleDropDownPopup = { handleDropDownPopup }
				isModerator         = { isModerator }
				isOwnProfile        = { isOwnProfile }
				isPopUpOpen         = { isPopUpOpen }
				isStreamer          = { isStreamer }
				profileHref         = { profileHref }
				selectedComment     = { selectedComment }
				userPopover         = { userPopover }
			/>
		);
	}

	if ( comment?.options )
		return (
			<RenderPollComments
				comment     = { comment }
				isStreamer  = { isStreamer }
				togglePolls = { togglePolls }
			/>
		);

	return (
		<RenderChatTip
			comment         = { comment }
			handleChatTips  = { handleChatTips }
			handleModal     = { handleModal }
			isFollowingUser = { isFollowingUser }
			isStreamer      = { isStreamer }
			streamerName    = { streamerName }
			userId          = { userId }
		/>
	);
};

export default component;
